import { IEnvironment } from './environment.interface';
export const environment: IEnvironment = {
  production: true,
  api: 'https://api.dongnai.ttgt.vn/admin/',
  auth0: {
    domain: 'ttgt-dongnai.us.auth0.com',
    clientID: 'UF70HlNxQndkRO0XZJ6o5m59EymD7bJ8',
    audience: 'https://ttgt-dongnai.us.auth0.com/userinfo',
    callback: 'https://feedback.dongnai.ttgt.vn/#/callback/',
  },
};



// WEBPACK FOOTER //
// /ng-app/src/environments/environment.ts